import { render } from "./operat.vue?vue&type=template&id=7e32a84e&scoped=true&ts=true"
import script from "./operat.vue?vue&type=script&lang=tsx"
export * from "./operat.vue?vue&type=script&lang=tsx"

import "./operat.vue?vue&type=style&index=0&id=7e32a84e&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e32a84e"]])

export default __exports__